import React, { useEffect } from 'react';
import { useSSR } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import 'apps/promo/components/i18n';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import isPropValid from '@emotion/is-prop-valid';
import { trackPageTranslation } from 'apps/promo/analytics/pageTranslation';
import PromoApp from 'apps/promo/components/PromoApp';
import PromoErrorBoundary from 'apps/promo/components/utils/PromoErrorBoundary';
import { getThemeFromUrl } from 'apps/promo/helpers/theme';
import getStore from 'apps/promo/redux/store';
import promoRoutes from 'apps/promo/routes/promoRoutes';
import { getShortActiveRoute } from 'apps/promo/routes/routesNoAuthUtils';
import { isShortActiveUrl, pushPath } from 'apps/promo/routes/routesUtils';
import pallets from 'apps/promo/theme/pallets';
import { hydrateRoot } from 'react-dom/client';
import 'static/css/global.css';
import 'apps/promo/theme/colors.css';
import 'apps/promo/theme/rebranding.css';
import 'static/css/promo-common.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import 'static/css/fonts.css';

const preloadedState = window.__INITIAL_STATE__;
delete window.__INITIAL_STATE__;
const store = getStore(preloadedState);
const state = store.getState();
const isShortLink = isShortActiveUrl(location.pathname);

const preprocessRoutes = isShortLink ? getShortActiveRoute(location.pathname) : pushPath(promoRoutes, []);

const PromoHydryte = () => {
    useEffect(() => trackPageTranslation(), []);
    useSSR(window.initialI18nStore, window.initialLanguage);

    const theme = getThemeFromUrl(location.search);

    return (
        <BrowserRouter>
            <StyleSheetManager shouldForwardProp={isPropValid}>
                <ThemeProvider theme={pallets[theme]}>
                    <Provider store={store}>
                        <PromoErrorBoundary>
                            <PromoApp redirectTo={state.app.redirectTo} routes={preprocessRoutes} />
                        </PromoErrorBoundary>
                    </Provider>
                </ThemeProvider>
            </StyleSheetManager>
        </BrowserRouter>
    );
};
const container = document.getElementById('app');
if (container) {
    hydrateRoot(container, <PromoHydryte />);
}
